import React, { useState } from 'react'

export const HoverableTextButton = props => {
    return (
        <button type="button" {...props}>
            {props.text}
        </button>
    )
}
